import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthService from "common/services/users/AuthService";

/** Async Thunks */

export const login = createAsyncThunk("user/login", async({email, password, rememberMe}, { rejectWithValue }) => {
  try {
    const cognitoUser = await AuthService.login(email, password, rememberMe)
    return cognitoUser;
  } catch (error) {
    console.error("Login error: ", error);
    return rejectWithValue(error);
  }
});

/** Initial State */

const initialState = {
  username: '',
  email: '',
  level: 99,
  isAuthenticating: false,
  isLoggedIn: localStorage.getItem("isAuthenticated") === 'true' ? true : false,
  loading: {
    login: false
  }
};

/** Slice */

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    handleUserData: (state, action) => {
      const idToken = action.payload.idToken;
      state.username = idToken.payload['cognito:username'];
      state.email = idToken.payload.email;
      state.level = Number.parseInt(idToken.payload['custom:level']);
    },
    handleIsLoggedIn: (state, action) => {
      if (action.payload) {
        localStorage.setItem("isAuthenticated", "true");
        state.isLoggedIn = true;
      } else {
        localStorage.setItem("isAuthenticated", "false");
        state.isLoggedIn = false;
      }
    },
    handleIsAuthenticating: (state, action) => {
      state.isAuthenticating = action.payload;
    },
    handleUserLevel: (state, action) => {
      state.level = action.payload;
    },
    completeLogin: (state) => {
      state.loading.login = false;
    },
    clearUser: (state) => {
      localStorage.clear();
      state = initialState;
    }
  },
  extraReducers: builder => {
    builder.addCase(login.pending, (state, action) => {
      state.loading.login = true;
    });
    builder.addCase(login.fulfilled, (state, action) => {
      const idToken = action.payload.signInUserSession.idToken;
      state.username = idToken.payload['cognito:username'];
      state.email = idToken.payload.email;
      state.level = Number.parseInt(idToken.payload['custom:level']);
      localStorage.setItem("isAuthenticated", "true");
      state.isLoggedIn = true;
      state.isAuthenticating = false;
    });
    builder.addCase(login.rejected, (state, action) => {
      state.loading.login = false;
    });
  }
});

export const { 
  handleUserData,
  handleIsLoggedIn,
  handleIsAuthenticating,
  handleUserLevel,
  completeLogin,
  clearUser
} = userSlice.actions;
export default userSlice.reducer;